<script setup lang="ts">
const showModal = defineModel<boolean>('showModal', { default: false, required: true })
const props = defineProps<{ title?: string }>()
const emit = defineEmits<{
  onModalClose: []
}>()
function closeModal() {
  showModal.value = false
  emit('onModalClose')
}
</script>

<template>
  <transition name="fade">
    <div
      v-if="showModal"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-opacity-50"
      @click.self="closeModal()"
    >
      <transition name="scale">
        <div
          v-if="showModal"
          class="flex max-h-2/3 w-full max-w-lg flex-col rounded-2xl bg-white p-6 shadow-xl"
        >
          <div class="mb-4 flex items-start justify-between">
            <h2 class="text-xl font-semibold text-gray-900">{{ props.title }}</h2>
            <button @click="closeModal()" class="text-gray-400 hover:text-gray-600">
              <span class="text-2xl">&times;</span>
            </button>
          </div>
          <div class="h-full w-full overflow-auto">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scale-enter-active,
.scale-leave-active {
  transition: transform 0.2s ease;
}
.scale-enter-from,
.scale-leave-to {
  transform: scale(0.95);
}
</style>
